export default __webpack_public_path__ + "static/media/blog2.df7996bd.svg";